import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAnswerOrder, IQuestion, ISaveAnswerParams } from '@interfaces/index';
import { AssessmentService } from '../../services/assessment.service';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'app-single-choice',
  templateUrl: './single-choice.component.html',
  styleUrl: './single-choice.component.scss'
})
export class SingleChoiceComponent {

  @Input() question: IQuestion | null = null;
  @Input() token: string | null = null;
  @Output() onNext: EventEmitter<void> = new EventEmitter()

  selected: number | null = null;
  constructor(
    public assessment_service: AssessmentService
  ) { }

  ngOnInit() {
    this.selected = this.question?.answer_order.find((item: IAnswerOrder) => {
      return item.selected
    })?.answer_id ?? null;
  }

  displayAgreement(section_name: string): boolean {
    return section_name === "Section 1 - Agreement";
  }

  save(input: MatRadioChange) {
    this.selected = input.value;
    const answer = this.question?.answer_order.find(
      (item: IAnswerOrder) => {
        return item.answer_id === this.selected;
      }
    )

    if (answer) {
      answer.selected = true;
  
      this.assessment_service.saveAnswer<ISaveAnswerParams<IAnswerOrder>>({
        answer: answer,
        question_id: (this.question as IQuestion).question_id,
        token: this.token as string
      }).subscribe(
        () => {
          (this.question as IQuestion).user_answer_ind = 1;
          this.onNext.emit()
        }
      )
    }
  }

}
